import { Directive, Input, ElementRef } from '@angular/core';
import { fromEvent, Subject } from 'rxjs';

@Directive({
  selector: '[appFormEvents]',
})
export class FormEventsDirective {
  @Input('appFormEvents') formEvents: Subject<any>;

  constructor() {}

  get events() {
    return this.formEvents;
  }
}
